import React from 'react';
import { useTranslation } from 'next-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Offset from './Offset';
import Figure from '../molecules/Figure';
import Empty from '../atoms/Empty';
import Button from '../atoms/Button';
import AddItem from '../molecules/AddItem';
import ItemContactsForm from './ItemContactsForm';
import { ContactCard } from '../../graphql/types';

interface ItemContactsProps {
  venueID?: string;
  serviceProviderID?: string;
  data: ContactCard[];
  access?: boolean;
  apply: (id: string, data: any) => void;
  setLayer: (el: any) => void;
}

const ItemContacts = (props: ItemContactsProps) => {
  const { t } = useTranslation(['common', 'venue', 'service']);
  const { venueID, serviceProviderID, data, access, setLayer } = props;
  const itemType = !!venueID ? 'venue' : 'service';

  return (
    <Row className={'contact'}>
      <Col xs={8}>
        <h2>{t(`${itemType}:contacts:headline`)}</h2>
        {!!access && (
          <AddItem
            restricted={false}
            label={t(`${itemType}:contacts:add`)}
            href="/promote-your-business"
            onClick={() =>
              setLayer(
                <ItemContactsForm
                  venueID={venueID}
                  serviceProviderID={serviceProviderID}
                  onSubmit={() => setLayer(null)}
                  onCancel={() => setLayer(null)}
                />
              )
            }
          />
        )}
        {!!data.length ? (
          <Offset>
            {data.map((el: any, i: number) => {
              const img = el.image ? el.image.url : '';
              const href = el.email ? `mailto:${el.email}` : '';
              const icon = !!!img ? 'contact' : '';
              const name = `${el.name}`;
              const department = el.title;
              return (
                <Figure
                  tiny
                  key={i}
                  className="col-s"
                  icon={icon}
                  img={img}
                  href={href}
                  title={name}
                  caption={
                    <>
                      <span>
                        {department && (
                          <>
                            {t(`common:${el.title}`)}
                            <br />
                          </>
                        )}
                        {el.email}
                        <br />
                        {el.phone}
                      </span>
                      {!!access && (
                        <>
                          <br />
                          <Button
                            tiny
                            dark
                            icon={'edit'}
                            label={t(`common:cta-edit`)}
                            onClick={() =>
                              setLayer(
                                <ItemContactsForm
                                  venueID={venueID}
                                  serviceProviderID={serviceProviderID}
                                  prefill={el}
                                  onSubmit={() => setLayer(null)}
                                  onCancel={() => setLayer(null)}
                                />
                              )
                            }
                          />
                        </>
                      )}
                    </>
                  }
                />
              );
            })}
            <br />
            <br />
          </Offset>
        ) : (
          <Empty label={t(`${itemType}:contacts:empty`)} />
        )}
      </Col>
    </Row>
  );
};

export default ItemContacts;
